const redirect = (url: string) => {
  window.location.href = url
  return
}

export default redirect
